import type { FastifyInstance } from 'fastify'
import { budgetRoutes } from './budget.routes.js'

export async function budgetModule(fastify: FastifyInstance) {
  await fastify.register(budgetRoutes)
}

export default budgetModule
